<div class="home-banner">
  <div class="banner-content" [@simpleFadeAnimation]="'in'">
    <div class="banner-title">
      Getting into Game Dev
    </div>
    <div class="banner-subtitle">
      Translating web dev knowledge to Game Dev
    </div>
  </div>
</div>
<div class="home-section">
  <app-featured-display></app-featured-display>
</div>

<div class="page">

  <div class="home-section">
    <app-game-display [games]="games$ | async"></app-game-display>
  </div>
  <div class="home-section">
    <app-app-display></app-app-display>
  </div>
</div>
